import React, { ReactNode } from 'react';
import { connect, useDispatch } from 'dva';
import * as actions from '@/models/actions';
import { GlobalState } from '@/models/types';
import { ISTSToken } from '@/models/auth';
import { MTools } from '@/components';
import OSS from 'ali-oss';
import styles from './index.less';


interface IDownloadProps {
  children?: ReactNode;
  stsToken: ISTSToken;
  ossKey: string;
  name?: string;
}

const DownloadComponent: React.FC<IDownloadProps> = ({
  stsToken, children, ossKey, name,
}) => {
  const dispatch = useDispatch();

  const getSTSToken = async () => {
    const currentTime = +new Date();
    if (!stsToken.expiration || +new Date(stsToken.expiration) < currentTime) {
      const newStsToken: ISTSToken = await new Promise((res) => {
        dispatch(actions.authActions.effects.getOssStsToken({
          onResult: (err, data) => {
            if (err) {
              console.error(data, '获取stsToken失败');
              throw new Error(data);
            } else {
              res(data);
            }
          },
        }));
      });
      return newStsToken;
    }
    return stsToken;
  };

  const download = async () => {
    try {
      const {
        securityToken, accessKeySecret, accessKeyId, bucketName,
      } = await getSTSToken();
      const client = new OSS({
        stsToken: securityToken,
        accessKeySecret,
        accessKeyId,
        bucket: bucketName,
        region: 'oss-cn-beijing',
      });
      const downloadUrl = client.signatureUrl(ossKey, {
        response: {
          'content-disposition': `attachment; filename=${name ? name + ossKey.slice(ossKey.lastIndexOf('.')) : ossKey}`,
        },
      });
      window.open(downloadUrl);
    } catch (error) {
      MTools.Tips('error', error);
    }
  };


  return (
    <div className={styles.download} onClick={() => download()}>
      {children}
    </div>

  );
};

const mapStateToProps = (state: GlobalState) => {
  return {
    stsToken: state.auth.stsToken,
  };
};
export default connect(mapStateToProps)(DownloadComponent);
